require('./dist/bi-logger/wix-bi-angular');

module.exports = 'wix.common.bi';

/*** EXPORTS FROM exports-loader ***/
